import styles from './colors.module.scss';

export const colors: any = {
  black: styles.black,
  white: styles.white,

  primary_20: styles.primary_20,
  primary_30: styles.primary_30,
  primary_35: styles.primary_35,
  primary_40: styles.primary_40,
  primary_45: styles.primary_45,
  primary_50: styles.primary_50,
  primary_60: styles.primary_60,
  primary_70: styles.primary_70,
  primary_80: styles.primary_80,
  primary_90: styles.primary_90,

  secondary_40: styles.secondary_40,
  secondary_80: styles.secondary_80,

  gradient_20: styles.gradient_20,
  gradient_40: styles.gradient_40,
  gradient_60: styles.gradient_60,
  gradient_80: styles.gradient_80,

  error_20: styles.error_20,
  error_30: styles.error_30,
  error_40: styles.error_40,
  error_45: styles.error_45,
  error_50: styles.error_50,
  error_60: styles.error_60,
  error_80: styles.error_80,

  red_80: styles.red_80,

  neutral_20: styles.neutral_20,
  neutral_30: styles.neutral_30,
  neutral_40: styles.neutral_40,
  neutral_60: styles.neutral_60,
  neutral_80: styles.neutral_80,
  neutral_90: styles.neutral_90,

  warning_40: styles.warning_40,
  warning_50: styles.warning_50,
  warning_60: styles.warning_60,
  warning_80: styles.warning_80,
  warning_90: styles.warning_90,

  green_30: styles.green_30,
  green_50: styles.green_50,
  green_70: styles.green_70,
  green_80: styles.green_80,
  green_90: styles.green_90,

  accent_40: styles.accent_40,
  highlight_40: styles.highlight_40,
  highlight_50: styles.highlight_50,

  yellow_30: styles.yellow_30,
  yellow_20: styles.yellow_20,
  yellow_40: styles.yellow_40,
  yellow_50: styles.yellow_50,
  yellow_60: styles.yellow_60,
};
